export const semanticMapJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Pacific Crest Properties",
  url: "https://pacificcrestprop.com",
  inLanguage: "en-US",
  publisher: {
    "@type": "Organization",
    name: "Pacific Crest Properties",
    slogan: "From Coast to Crest — Real Estate Elevated",
  },
  about: {
    "@type": "Organization",
    name: "Pacific Crest Properties",
    description:
      "Pacific Crest Properties is a Los Angeles real estate solutions company offering two primary services: fast, as-is property offer options and modern renovation services.",
    telephone: "(310) 596-6534",
    email: "office@pacificcrestprop.com",
    address: {
      "@type": "PostalAddress",
      streetAddress: "732 South 6th Street, STE N",
      addressLocality: "Las Vegas",
      addressRegion: "NV",
      postalCode: "89101",
      addressCountry: "US",
    },
  },
  potentialAction: [
    {
      "@type": "ViewAction",
      name: "Get a property offer",
      target: "https://offer.pacificcrestprop.com",
    },
    {
      "@type": "ViewAction",
      name: "Request a renovation quote",
      target: "https://renovation.pacificcrestprop.com",
    },
  ],
  areaServed: [
    "Los Angeles",
    "Culver City",
    "Inglewood",
    "Pasadena",
    "San Gabriel Valley",
    "West LA",
    "Valley communities",
    "San Marino",
    "Monterey Park",
    "South Pasadena",
    "Montebello",
    "La Puente",
    "Alhambra",
    "Diamond Bar",
    "Chino Hills",
    "Rosemead",
    "San Gabriel",
    "Arcadia",
    "Monrovia",
    "Baldwin Park",
    "Whittier",
    "Hacienda Heights",
    "Rowland Heights",
    "Walnut",
    "West Covina",
    "Covina",
    "El Monte",
    "Temple City",
    "Rancho Cucamonga",
    "Azusa",
    "Glendora",
    "San Dimas",
    "Chino",
    "Ontario",
    "Claremont",
    "Montclair",
    "La Verne",
  ],
};

export function serializeJsonLd(obj) {
  return JSON.stringify(obj).replace(/</g, "\\u003c");
}
